import { okhsl } from '../../../../d3-mapp/color/index.js';
export const getPieChartSectionData = (data, configuration, returnAll //set to true for reports, otherwise add filter selector
) => {
    return configuration.options.sections.map((sectionDef) => {
        const sectionData = (getPieChartsData(data, sectionDef.charts, returnAll).filter((pcd) => !!pcd));
        //		const title = sectionData.map((pcd) => pcd.title).join(' / ');
        const title = getSectionTitle(sectionDef.charts, returnAll).filter((title) => !!title).join(' / ');
        return { title, sectionData };
    });
};
const getSectionTitle = (chartDefs, returnAll //set to true for reports, otherwise add filter selector
) => {
    return chartDefs.flatMap((chartDef) => {
        if (chartDef.type === 'pie') {
            return chartDef.label;
        }
        else if (chartDef.type === 'filteredPie') {
            const filteredChartDef = chartDef;
            const filterNotSet = !filteredChartDef.filterValue || filteredChartDef.filterValue.length === 0;
            if (filterNotSet && returnAll) {
                const filterValueLabel = filteredChartDef.values.map((filterValueDef) => filterValueDef.label);
                return chartDef.label + ' ' + filterValueLabel.join(', ');
            }
            else {
                const filterValue = (!filteredChartDef.filterValue || filteredChartDef.filterValue.length === 0) ? (filteredChartDef.isMultiValueFilter
                    ? [filteredChartDef.values[0].value]
                    : filteredChartDef.values[0].value) : filteredChartDef.filterValue;
                const filterValueLabel = filterValue.push
                    ? filterValue
                        .map((filterValue) => filteredChartDef.values[filteredChartDef.map[filterValue]].label)
                        .toString()
                    : filteredChartDef.values[filteredChartDef.map[filterValue]].label;
                return chartDef.label + ' ' + filterValueLabel;
            }
        }
        else {
            // unknown so skip
            console.log('Skipping chart of unknown type %s', chartDef.type);
            return undefined;
        }
    });
};
const getPieChartsData = (data, chartDefs, returnAll //set to true for reports, otherwise add filter selector
) => {
    return chartDefs.flatMap((chartDef, chartIndex) => {
        if (chartDef.type === 'pie') {
            return getPieChartData(data, chartDef);
        }
        else if (chartDef.type === 'filteredPie') {
            return getFilteredPieChartData(data, chartDef, returnAll);
        }
        else {
            // unknown so skip
            console.log('Skipping chart of unknown type %s', chartDef.type);
            return undefined;
        }
    });
};
const getPieChartData = (data, chartDef) => {
    const valueDistribution = getChartData(data, chartDef)[0];
    return valueDistribution;
};
const getFilteredPieChartData = (data, chart, returnAll //set to true for reports, otherwise add filter selector
) => {
    const originalFilterValue = chart.filterValue;
    const originalFilterValueLabel = chart.filterValueLabel;
    const filterNotSet = !chart.filterValue || chart.filterValue.length === 0;
    if (filterNotSet && returnAll) {
        const valueDistributions = chart.values.flatMap((filterValueDef) => {
            chart.filterValue = filterValueDef.value;
            chart.filterValueLabel = filterValueDef.label;
            return getChartData(data, chart);
        });
        chart.filterValue = originalFilterValue;
        chart.filterValueLabel = originalFilterValueLabel;
        return valueDistributions;
    }
    else {
        // set filterValue if that hasn't been done (by fixed
        // value(s) in definition or by manual select)
        if (!chart.filterValue || chart.filterValue.length === 0) {
            chart.filterValue = chart.isMultiValueFilter
                ? [chart.values[0].value]
                : chart.values[0].value;
        }
        // set filterValue label
        chart.filterValueLabel = chart.filterValue.push
            ? chart.filterValue
                .map((filterValue) => chart.values[chart.map[filterValue]].label)
                .toString()
            : chart.values[chart.map[chart.filterValue]].label;
        const valueDistributions = getChartData(data, chart);
        chart.filterValue = originalFilterValue;
        chart.filterValueLabel = originalFilterValueLabel;
        return valueDistributions;
    }
};
const getChartData = (data, chart) => {
    // determine which filter to apply to the set of dataItems
    const pass = chart.filterBy && chart.filterValue
        ? chart.filterValue.push
            ? (datum) => chart.filterValue.indexOf(chart.value(datum)) != -1
            : (datum) => chart.filterValue === chart.value(datum)
        : (_datum) => true;
    // actually select the dataItems to use (can be the complete set)
    const selectedDataItems = data.filter(pass);
    // calculate all value distributions for this chart (can be multiple
    // distributions that have all been based on the same filtered data set)
    let chartsData = chart.charts
        ? chart.charts.map((subChart) => {
            const chartData = getFilteredChartData(selectedDataItems, subChart);
            if (chart.filterValueLabel) {
                chartData.title += ` ${chart.filterValueLabel}`;
            }
            return chartData;
        })
        : [getFilteredChartData(selectedDataItems, chart)];
    // return an array with all distributions
    return chartsData;
};
const getFilteredChartData = (data, chart) => {
    let totalCount = data.length;
    let max = undefined;
    let min = undefined;
    let valueDistribution = chart.values
        .map((valueProps) => ({
        key: valueProps.value,
        label: valueProps.label,
        color: okhsl(valueProps.color),
        value: 0.0,
        count: 0,
        index: valueProps.index
    }))
        .sort((d0, d1) => d0.index - d1.index)
        .reduce((distribution, entry) => {
        distribution[entry.key] = entry;
        return distribution;
    }, {});
    if (data.length > 0) {
        // count the number of occurrences for each (enum) value
        data.forEach((datum) => {
            const value = chart.value(datum);
            if (valueDistribution[value]) {
                valueDistribution[value].count++;
                valueDistribution[value].value = valueDistribution[value].count;
                max = max === undefined ? value : valueDistribution[value].count > valueDistribution[max].count ? value : max;
                min = min === undefined ? value : valueDistribution[value].count < valueDistribution[min].count ? value : min;
            }
            else {
                totalCount--;
            }
        });
        // calculate the values : the percentages
        Object.values(valueDistribution).forEach((datum) => (datum.value = datum.count / totalCount));
    }
    return { title: chart.label, distribution: valueDistribution, count: totalCount, max, min };
};
